import { Component, input, inject, signal, ChangeDetectionStrategy } from "@angular/core";
import { AsyncWrapperComponent } from "@fry-it/risr-core";
import { ReportResult } from "../report-run/report-result/report-result";
import { ReportStore } from "../../services/report-store";
import { MatButtonModule } from "@angular/material/button";
import { RouterLink } from "@angular/router";
import { ReportRunState } from "../report-run/report-run-state";
import { asyncWrapper } from "@fry-it/risr-core";

export interface ReportWidgetConfig {
    report: string;
    model: any;
}

@Component({
    selector: 'kz-report-widget',
    templateUrl: './report-widget.html',
    imports: [
        AsyncWrapperComponent,
        ReportResult,
        MatButtonModule,
        RouterLink
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        ReportRunState
    ]
})
export class ReportWidgetComponent {

    config = input.required<ReportWidgetConfig>()
    username = input.required<string>()

    private readonly reportStore = inject(ReportStore);
    private readonly reportRunState = inject(ReportRunState);

    protected reportId = signal<string>('');

    protected canNavigateTo = signal<boolean>(false);
    reportReady = asyncWrapper(() => this.reportRunState.run(), { autoLoad: false});

    async ngOnInit() {
        const report = await this.reportStore.getByGroup(this.config().report)
        const canNavigateTo = await this.reportStore.getMetadataFor(report.id, this.username());
        this.reportRunState.initialize(
            report.id,
            report.report.display,
            this.config().model,
            {
                showType: 'widget',
            },
            this.username(),
        );
        this.canNavigateTo.set(canNavigateTo.canNavigateTo);
        this.reportId.set(report.id);
        this.reportReady.load();
    }

}
